import {Component, OnDestroy, OnInit} from '@angular/core';
import {DatePipe} from "@angular/common";
import {PopupService} from "../../services/popup.service";
import {selectReport, selectReportError} from "../../state/search/search.selectors";
import {filter, Subscription, take} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "../../state/app.state";
import {ReportService} from "../../services/report.service";
import {fetchSelfReport, clearReport} from "../../state/search/search.actions";
import {ActivatedRoute} from "@angular/router";
@Component({
  selector: 'app-public-profile',
  templateUrl: './public-profile.component.html',
  styleUrl: './public-profile.component.scss'
})
export class PublicProfileComponent implements OnInit,OnDestroy{
    emails:any;
    phoneNumbers:any;
    socialProfiles : any;
    loading: boolean;
    assistantPrompts: any;
    company: any;
    public_profile_url: any;
    userId: number;
    report_not_found: boolean;
    search_not_found: boolean;

    // Email and phone counts
    emailsCount: number = 0;
    phoneNumbersCount: number = 0;


  constructor(

      private store: Store<AppState>,
      public reportService: ReportService,
      private route: ActivatedRoute,
  ) {
  }
  prospect_insights:any
  personExpanded: boolean | undefined = true
  companyExpanded: boolean | undefined = true
  report:any;
  name:any;
  private reportSuccessSubscription: Subscription;
  private reportFailureSubscription: Subscription;
  ngOnInit() {


    // clear report on init and after we reload
    this.store.dispatch(clearReport());

    window.onbeforeunload = () => {
      this.store.dispatch(clearReport());
    };
    
    this.loading = true
    this.search_not_found = false;
    this.public_profile_url = this.route.snapshot.paramMap.get('name-profile-id');
    if (this.public_profile_url)
          this.fetchSelfReport(this.public_profile_url);
    else {
      this.search_not_found = true;
      this.loading = false;
    }

  }
  fetchSelfReport(public_profile_url: number): void {
    this.loading = true;

    this.store.dispatch(fetchSelfReport({public_profile_url}));

    this.reportSuccessSubscription = this.store.select(selectReport)
        .pipe(
          filter(response => response !== null && response.report !== null),
          take(1)
        )
        .subscribe({
          next: (response) => {
            // Always set loading to false first to prevent stuck loading screen
            this.loading = false;

            try {
              console.log('[PublicProfile] Self Report fetched successfully', response);

              const report = response.report;
              if (!report) {
                console.error('[PublicProfile] Report data is missing in response');
                this.search_not_found = true;
                return;
              }

              this.report = report;
              this.assistantPrompts = report.assistant_prompts || [];

              this.reportService.updateReport(report);

              // Safely check for companies
              if (report.search_companies && Array.isArray(report.search_companies) && report.search_companies.length > 0) {
                this.setCurrentCompany(report.search_companies[0]);
              } else {
                console.log('[PublicProfile] Report search company was not found.');
              }

              // Check for person data
              if (!report.search_person) {
                console.log('[PublicProfile] Report search person was not found.');
              } else {
                // Count emails and phone numbers
                this.countEmails();
                this.countPhoneNumbers();
              }

              // Extract personal background insights
              this.extractPersonalBackgroundInsights();

            } catch (error) {
              console.error('[PublicProfile] Error processing report:', error);
              // Report loaded but has processing issues - don't show "not found" message
              // User can still see partial data
            }
          },
          error: (error) => {
            console.error('[PublicProfile] Subscription error:', error);
            this.loading = false;
            this.search_not_found = true;
          }
        });

    this.reportFailureSubscription = this.store.select(selectReportError)
        .pipe(filter(error => error !== null), take(1))
        .subscribe(error => {
          // console.error('Error fetching report:', error);

          this.search_not_found = true;
          this.loading = false;
        });
  }


  formatDate(date) {
    return new DatePipe('en-US').transform(date, 'MMM d');
  }
  receiveExpandedPersonAndCompany(expanded: boolean | undefined) {
    this.personExpanded = expanded
    this.companyExpanded = expanded
  }

  isEstimatedRevenueVisible = false;
  isEstimatedFundingVisible = false;

  showEstimedRevenueMessage() {

    this.isEstimatedRevenueVisible = true;
  }

  hideEstimedRevenueMessage() {
    this.isEstimatedRevenueVisible = false;
  }
  showEstimedFundingMessage() {

    this.isEstimatedFundingVisible = true;
  }

  hideEstimedFundingMessage() {
    this.isEstimatedFundingVisible = false;
  }

  getEmails(){
    // this.emails = [this.report.email,this.report.search_person.enhanced_data?.email]
    this.emails = [this.report.search_person.enhanced_data?.email];
    // remove duplicates
    return this.emails = Array.from(new Set(this.emails)).filter(value => value !== "" && value !=null)
  }
  getPhoneNumbers(){
    this.phoneNumbers = this.report.search_person.enhanced_data?.phone_numbers

    return this.phoneNumbers = Array.from(new Set(this.phoneNumbers)).filter(value => value !== "" && value !=null)

  }
  getSocialProfiles(){
    this.socialProfiles = [this.report.linkedin_profile,this.report.search_person.enhanced_data.facebook_url,this.report.search_person.enhanced_data.github_url,this.report.search_person.enhanced_data.twitter_url]

    return this.socialProfiles = Array.from(new Set(this.socialProfiles)).filter(value => value !== "" && value !=null)
  }

  setCurrentCompany(job) {
    try {
      this.company = job;
      this.report.companies.map(company => {
        company.selected = company.id === job.id
      });
    } catch {
      this.company= ''
    }
  }

  /**
   * Count unique emails from the report data
   * Removes duplicates and filters out null/empty values
   */
  countEmails(): void {
    try {
      const emails = [
        this.report?.email,
        this.report?.search_person?.enhanced_data?.email
      ];

      // Remove duplicates and filter out null/empty values
      const uniqueEmails = Array.from(new Set(emails)).filter(value => value !== "" && value != null);
      this.emailsCount = uniqueEmails.length;

      console.log('[PublicProfile] Email count:', this.emailsCount);
    } catch (error) {
      console.error('[PublicProfile] Error counting emails:', error);
      this.emailsCount = 0;
    }
  }

  /**
   * Count unique phone numbers from the report data
   * Removes duplicates and filters out null/empty values
   */
  countPhoneNumbers(): void {
    try {
      const phoneNumbers = this.report?.search_person?.enhanced_data?.phone_numbers || [];

      // Remove duplicates and filter out null/empty values
      const uniquePhoneNumbers = Array.from(new Set(phoneNumbers)).filter(value => value !== "" && value != null);
      this.phoneNumbersCount = uniquePhoneNumbers.length;

      console.log('[PublicProfile] Phone number count:', this.phoneNumbersCount);
    } catch (error) {
      console.error('[PublicProfile] Error counting phone numbers:', error);
      this.phoneNumbersCount = 0;
    }
  }

  /**
   * Extract personal background insights from the report data
   * Follows path: insights -> personal_background -> response -> short
   */
  extractPersonalBackgroundInsights(): void {
    try {
      // Access the insights data structure
      const insights = this.report?.insights;
      if (!insights) {
        console.log('[PublicProfile] No insights found in report');
        this.prospect_insights = 'N/A';
        return;
      }

      // Access personal_background -> response -> short
      const personalBackground = insights?.personal_background;
      if (!personalBackground) {
        console.log('[PublicProfile] No personal_background found in insights');
        this.prospect_insights = 'N/A';
        return;
      }

      const response = personalBackground?.response;
      if (!response) {
        console.log('[PublicProfile] No response found in personal_background');
        this.prospect_insights = 'N/A';
        return;
      }

      const shortDescription = response?.short;
      if (!shortDescription) {
        console.log('[PublicProfile] No short description found in response');
        this.prospect_insights = 'N/A';
        return;
      }

      this.prospect_insights = shortDescription;
      console.log('[PublicProfile] Personal background insights extracted:', this.prospect_insights);
    } catch (error) {
      console.error('[PublicProfile] Error extracting personal background insights:', error);
      this.prospect_insights = 'N/A';
    }
  }

  ngOnDestroy() {

    this.loading = true
    this.store.dispatch(clearReport());
    // console.log('Report data cleared on component destruction');
    this.reportSuccessSubscription?.unsubscribe();
    this.reportFailureSubscription?.unsubscribe();
    this.report = null;
    this.userId = null;
    this.search_not_found = false;
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/human.svg'; // Fallback image when error occurs
  }

}
